/* import __COLOCATED_TEMPLATE__ from './debt-error-details-row.hbs'; */
import Component from '@glimmer/component';
import { service } from '@ember/service';
import { action } from '@ember/object';

import Constants from '../utils/constants';
import kebabCase from 'lodash.kebabcase';
import { htmlSafe } from '@ember/template';

// Help display imports
import BiasCurrentErrorHelp from './help/error/bias-current';
import CmrrOffsetErrorHelp from './help/error/cmrr-offset';
import GainTempcoErrorHelp from './help/error/gain-tempco';
import GainErrorHelp from './help/error/gain';
import InitialErrorHelp from './help/error/initial';
import InlErrorHelp from './help/error/inl';
import IoCurrentErrorHelp from './help/error/io-current';
import IoVoltageDriftErrorHelp from './help/error/io-voltage-drift';
import IoVoltageErrorHelp from './help/error/io-voltage';
import LineRegErrorHelp from './help/error/line-reg';
import LoadRegErrorHelp from './help/error/load-reg';
import NoiseErrorHelp from './help/error/noise';
import OffsetErrorHelp from './help/error/offset';
import OffsetTempCoErrorHelp from './help/error/offset-tempco';
import OpenLoopGainErrorHelp from './help/error/open-loop-gain';
import OutNoiseErrorHelp from './help/error/out-noise';
import PsrrOffsetErrorHelp from './help/error/psrr-offset';
import ResistorTempcoErrorHelp from './help/error/resistor-tempco';
import ResistorToleranceErrorHelp from './help/error/resistor-tolerance';
import RsetTempcoErrorHelp from './help/error/rset-tempco';
import RsetToleranceErrorHelp from './help/error/rset-tolerance';
import TempcoErrorHelp from './help/error/tempco';
import TueIoutErrorHelp from './help/error/tue-iout';
import TueErrorHelp from './help/error/tue';

const ERROR_HELP_CLASSES = {
  'bias-current': BiasCurrentErrorHelp,
  'cmrr-offset': CmrrOffsetErrorHelp,
  'gain-tempco': GainTempcoErrorHelp,
  gain: GainErrorHelp,
  initial: InitialErrorHelp,
  inl: InlErrorHelp,
  'io-current': IoCurrentErrorHelp,
  'io-voltage-drift': IoVoltageDriftErrorHelp,
  'io-voltage': IoVoltageErrorHelp,
  'line-reg': LineRegErrorHelp,
  'load-reg': LoadRegErrorHelp,
  noise: NoiseErrorHelp,
  offset: OffsetErrorHelp,
  'offset-tempco': OffsetTempCoErrorHelp,
  'open-loop-gain': OpenLoopGainErrorHelp,
  'out-noise': OutNoiseErrorHelp,
  'psrr-offset': PsrrOffsetErrorHelp,
  'resistor-tempco': ResistorTempcoErrorHelp,
  'resistor-tolerance': ResistorToleranceErrorHelp,
  'rset-tempco': RsetTempcoErrorHelp,
  'rset-tolerance': RsetToleranceErrorHelp,
  tempco: TempcoErrorHelp,
  'tue-iout': TueIoutErrorHelp,
  tue: TueErrorHelp,
};

export default class DebtErrorDetailsRow extends Component {
  @service intl;

  get showCustomErrorInputs() {
    return window.toggledFeatures.customErrorInput;
  }

  get errorValue() {
    return this.args.model.signalChainHandler.getErrorValue(this.args.detail.id);
  }

  get isInvalidValue() {
    return this.args.detail.errorMessage && !this.args.detail.foundErrorData ? true : false;
  }

  get name() {
    return this.args.detail.nameFn(this.intl);
  }

  @action handleErrorInputChange(value) {
    if (value > 99999) value = 99999;
    this.args.model.signalChainHandler.updateErrorValue(this.args.detail.id, value);
    this.args.model.chartHandler.update(Constants.CHART_TYPES.ERROR_DISTRIBUTION);
    if (this.args.updateAppData) this.args.updateAppData();
  }

  @action validateErrorValue(result, originalValue) {
    if (result.raw < 0) {
      result.raw = originalValue;
      result.errorMessage = this.intl.t('messages.positive_value');
    }
  }

  @action getHelpModalData(translation) {
    if (translation) {
      return {
        text: htmlSafe(this.intl.t(`error_details_message.${translation}.text`)),
        title: htmlSafe(this.intl.t(`error_details_message.${translation}.title`)),
        componentName: `error/${kebabCase(translation)}`,
        componentClass: ERROR_HELP_CLASSES[kebabCase(translation)],
        helpText: `${translation}_error`,
      };
    } else return {};
  }
}
